var a = /* @__PURE__ */ ((o) => (o.download = "download", o.eCourse = "e-course", o.physicalProduct = "physical", o))(a || {});
export {
  a as ProductTypeEnum
};
